import React, { useEffect } from "react";
import TokenHistory from "../components/TokenHistory";
import { TokenStatics } from "../components/TokenStatics/TokenStatics";
import History from "./History";
import PoolList from "./PoolsList";
import "./styles/Token.scss";
const token = {
  address: "0xFf795577d9AC8bD7D90Ee22b6C1703490b6512FD",
  symbol: "DAI",
  logoURI:
    "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
};
const TokenInfo = () => {
  const [tab, setTab] = React.useState("info");

  return (
    <div className="token_page_container">
      <div className="token_page">
        <div className="token_info">
          <div className="title">
            <div>
              <img src={token.logoURI} alt="tokenlogo" />
              <h1>{token.symbol}</h1>
            </div>
            <div>
              <div
                onClick={() => setTab("pool")}
                className={`tabs ${tab === "pool" && "active"}`}
              >
                Pool
              </div>
              <div
                onClick={() => setTab("info")}
                className={`tabs ${tab === "info" && "active"}`}
              >
                Info
              </div>
            </div>
          </div>
          <div className="token_positions">
            <div className="cards">
              <div>
                <h2>TVL</h2>
                <h2>1,000,000</h2>
              </div>
              <div>
                <div>
                  <h3>Highest Lend APY</h3>
                  <h2>00.00</h2>
                </div>
                <div>
                  <h3>Highest Lend APY</h3>
                  <h2>00.00</h2>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="title">
                <h2>Lend Position</h2>
              </div>
              <div className="lend_borrow_info">
                <div>
                  <img src={token.logoURI} alt="tokenlogo" />
                  <h2>500</h2>
                </div>
                <h2>~500</h2>
              </div>
            </div>
            <div className="cards">
              <div className="title">
                <h2>Borrow Position</h2>
              </div>
              <div className="lend_borrow_info">
                <div>
                  <img src={token.logoURI} alt="tokenlogo" />
                  <h2>500</h2>
                </div>
                <h2>~500</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
     { tab==='pool' && <PoolList fromToken={true}/> }
     { tab==='info' && <TokenStatics token={token}/> }
    </div>
  );
};

export default TokenInfo;
